/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to five: max-resolution (1280×720), standard (640×480), high (480×360), medium (320×180) and default (120×90). Older or lower-quality videos may not have the largest sizes.`)
};

const es_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta cinco: máxima resolución (1280×720), estándar (640×480), alta (480×360), media (320×180) y predeterminada (120×90). Los videos antiguos o de menor calidad pueden no tener los tamaños más grandes.`)
};

const de_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu fünf: Maximalauflösung (1280×720), Standard (640×480), Hoch (480×360), Mittel (320×180) und Standardvorschau (120×90). Bei älteren oder qualitativ schlechteren Videos fehlen die größten Größen manchmal.`)
};

const nl_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot vijf: maximale resolutie (1280×720), standaard (640×480), hoog (480×360), gemiddeld (320×180) en klein (120×90). Oudere video's of video's van lagere kwaliteit hebben de grootste formaten mogelijk niet.`)
};

const fr_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu’à cinq : résolution maximale (1280×720), standard (640×480), haute (480×360), moyenne (320×180) et par défaut (120×90). Les vidéos plus anciennes ou de moindre qualité peuvent ne pas disposer des plus grandes tailles.`)
};

const it_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fino a cinque: massima risoluzione (1280×720), standard (640×480), alta (480×360), media (320×180) e predefinita (120×90). I video più vecchi o di qualità inferiore potrebbero non avere le dimensioni più grandi.`)
};

const pt_br2_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até cinco: resolução máxima (1280×720), padrão (640×480), alta (480×360), média (320×180) e default (120×90). Vídeos mais antigos ou de qualidade menor podem não ter os tamanhos maiores.`)
};

const pt_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até cinco: resolução máxima (1280×720), padrão (640×480), alta (480×360), média (320×180) e predefinida (120×90). Vídeos mais antigos ou de qualidade inferior podem não ter os tamanhos maiores.`)
};

const ja_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大5種類あります：最大解像度（1280×720）、標準（640×480）、高（480×360）、中（320×180）、デフォルト（120×90）です。古い動画や低画質の動画では、最大サイズが用意されていない場合があります。`)
};

const zh_yt_hub_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多五种：max-resolution（1280×720）、standard（640×480）、high（480×360）、medium（320×180）和 default（120×90）。较旧或画质较低的视频可能没有最大尺寸。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq2_a", locale)
	if (locale === "en") return en_yt_hub_faq2_a(inputs)
	if (locale === "es") return es_yt_hub_faq2_a(inputs)
	if (locale === "de") return de_yt_hub_faq2_a(inputs)
	if (locale === "nl") return nl_yt_hub_faq2_a(inputs)
	if (locale === "fr") return fr_yt_hub_faq2_a(inputs)
	if (locale === "it") return it_yt_hub_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq2_a(inputs)
	if (locale === "pt") return pt_yt_hub_faq2_a(inputs)
	if (locale === "ja") return ja_yt_hub_faq2_a(inputs)
	return zh_yt_hub_faq2_a(inputs)
};